import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';
import { getMemberinfo, regPhone, patternPwCker, useIntersectionObserver } from "../../utils/utils";
import DaumPostcode from 'react-daum-postcode';

import * as APIS from "../../utils/service";


export default function Noticelist({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const target = useRef(null);

    const [memberinfos, setmemberinfos] = useState(''); 
    const [lists, setlists] = useState([]); 
    const [page, setPage] = useState(0);   

    const [observe, unobserve] = useIntersectionObserver(() => {
        setPage((page) => page + 1);
    });


    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
   
    useEffect(() => {
        listopen();
        setPage(1);
        observe(target.current);
    }, []);
    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            rolling: false
        }
        APIS.postData('/v1/news/list', sender).then(({ data }) => {
            if(data){
                data.sort(function (a, b) {
                    if(a.hasOwnProperty('required')){
                        return b.required - a.required;
                    }
                });
                setlists(data);
                //console.log(data);

            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });           
    }
    return(
        <Layout header={false} actives={''}>
            <div className='customercenter'>
                <div className='pagetabs_white margint20'>
                    <button className='active' onClick={() => { navigate('/Noticelist') }}>공지사항</button>
                    <button onClick={() => { navigate('/Faqlist') }}>FAQ</button>
                    <button onClick={() => { navigate('/Useguidelist')}}>이용가이드</button>
                </div>
                <div className='customercenterPage'>
                    <div className='fontsize24 bolds'>공지사항</div>
                    <div>
                        <div className='productlistArea' style={{ marginTop: 0 }}>
                            <div className="productlist_th">
                                <div style={{ width: 'calc(100% - 140px)'}}>제목</div>                            
                                <div style={{ width: 140}}>날짜</div>                            
                            </div>
                            {lists?.length > 0 && lists?.map((x, i) => {
                                if(i > (page*10)){
                                    return;
                                }
                                return (
                                    <div 
                                        className={`productlist_td`}
                                        key={i}
                                        style={{
                                            cursor: 'pointer', 
                                        }}
                                        onClick={() => {
                                            navigate('/NoticeDetail', {state: { vidx: x?.idx }});
                                        }}
                                    >
                                        <div 
                                            className='textcut_online'
                                            style={{ 
                                                display: 'inline-block', width: 'calc(100% - 140px)', textAlign: 'left', lineHeight: '48px',
                                                paddingLeft: 20, fontWeight: 700
                                            }}
                                        >
                                            {x?.required*1 === 1 && <span className='noticedefault'>필독</span> }
                                            {x?.title}
                                        </div>  
                                        <div style={{ width: 140}}>{moment(x?.create_dt).format('YYYY.MM.DD')}</div>  
                                    </div>
                                );
                            })}
                            {lists?.length === 0 &&
                                <div className='nolistArea'>
                                    공지사항이 없습니다.
                                </div>
                            }
                            <div ref={target} style={{ width: '100%', height: 1 }} />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

